import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Icon from 'react-fa'
import HelpLink from '../HelpLink'

import './HelpIconLink.scss'

const HelpIconLink = props => (
  <div className='help-icon-link-wrapper'>
    <HelpLink className='help-link-anchor' helpTopic={props.helpTopic}>
      <Icon name='question' />
    </HelpLink>
  </div>
)

HelpIconLink.propTypes = {
  helpTopic: PropTypes.string.isRequired
}

export default HelpIconLink



// WEBPACK FOOTER //
// ./src/components/HelpIconLink/HelpIconLink.js